import React, { Fragment, useState, useEffect, useRef } from "react";
import CustomLoader from "../../customLoader/CustomLoader";
import GetAdminService from "../../../services/admin/GetAdminService";
import GetStudentService from "../../../services/SchoolIT/GetStudentService";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";

import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomPagination from "../../pagination/Pagination";
import CreateStudent from "./CreateStudent";
import "./Student.css";
import { useLocation, useHistory } from "react-router";
import swal from "sweetalert";

const Students = () => {
  const [schoolName, setSchoolName] = useState();
  const [showSchoolNameContainer, setShowSchoolNameContainer] = useState(false);
  const [schoolNameList, setSchoolNameList] = useState();
  const schoolNameRef = useRef();
  const timeoutRef = useRef();
  const [schoolNameLoading, setSchoolNameLoading] = useState(false);
  const [schoolId, setSchoolId] = useState();

  const studentInputRef = useRef();
  const timeout = useRef();
  const [searchInput, setSearchInput] = useState();
  const [page, setPage] = useState(1);
  const [studentListData, setStudentListData] = useState([]);
  const [optionValue, setOptionValue] = useState();
  const [modifyData, setModifyData] = useState({});
  const [modifyStudentIndex, setModifyStudentIndex] = useState();
  const [openCreateStudent, setOpenCreateStudent] = useState(false);
  const [openModifyStudent, setOpenModifyStudent] = useState(false);
  const [loading, setLoading] = useState(false);
  let location = useLocation();
  let history = useHistory();
  const [withoutCounselor, setWithoutCounselor] = useState(false);
  const impersonationReturnHandled = useRef(false);

  const getSchoolsList = (value) => {
    setSchoolNameList([]);
    setShowSchoolNameContainer(true);
    setSchoolNameLoading(true);
    GetAdminService.getSchoolsList(value)
    .then((data) => {
      setSchoolNameList(data?.data?.school);
      setSchoolNameLoading(false);
    })
    .catch((_error) => {
      setSchoolNameLoading(false);
    });
  };

  const getStudentwithId = (value, id = "", newpage = 0) => {
    setLoading(true);
    setSearchInput("");
    let obj = {
      page: page,
      role: "student",
      student: value
    };
    if (newpage === 1) {
      obj.page = 1;
      setPage(1);
    }
    setOptionValue(value);

    if (id) obj.school = id;else
    obj.school = schoolId;

    GetStudentService.getStudent(obj)
    .then((data) => {
      setStudentListData(data.data);
      setLoading(false);
    })
    .catch((_error) => {
      setLoading(false);
    });
  };

  const modifyStudent = (item, index) => {
    setModifyStudentIndex(index);

    // Store current student page state before opening modify drawer (for potential impersonation)
    const studentPageState = {
      schoolId: schoolId,
      schoolName: schoolName,
      searchInput: searchInput,
      optionValue: optionValue,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem('student_page_state', JSON.stringify(studentPageState));

    setLoading(true);
    GetStudentService.modifyStudent(item.id)
    .then((data) => {
      if (!data.data.objects) {
        setModifyData({
          student: {
            first_name: item?.first_name,
            last_name: item?.last_name,
            mobile: item?.mobile,
            email: item?.email,
            id: item?.id
          }
        });
      } else
      setModifyData(data.data.objects);
      setLoading(false);
      setOpenModifyStudent(true);
    })
    .catch((error) => {
      setLoading(false);
      swal({
        text: error?.response?.data?.error,
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: true,
          confirm: true
        },
        closeOnClickOutside: true
      });
    });
  };

  const getStudentfromSearchHandler = (value) => {
    let obj = {
      page: page,
      role: "student",
      school: schoolId,
      student_option: "",
      q: value
    };
    GetStudentService.getStudent(obj)
    .then((data) => {
      setStudentListData(data.data);
    })
    .catch(() => {});
  };

  useEffect(() => {
    if (!schoolId) return;
    if (withoutCounselor) {
      students_without_counselor(schoolId, page);
    } else {
      getStudentwithId(optionValue);
    }
  }, [page]);

  useEffect(() => {
    if (location?.pathname?.split("/").pop() === "students_without_counselor") {
      setWithoutCounselor(true);
    }
  }, []);

  // Handle return from impersonation - auto-open modify drawer
  useEffect(() => {
    // Check location.state first, then fallback to localStorage
    let shouldHandle = false;
    let returnSchoolId = null;
    let returnStudentId = null;
    let locationSearchInput = '';
    let locationOptionValue = 'all';
    let locationSchoolName = '';

    if (
    location?.state?.returnFromImpersonation &&
    !impersonationReturnHandled.current)
    {
      shouldHandle = true;
      returnSchoolId = location.state.schoolId;
      returnStudentId = location.state.studentId;
      // Capture search state from location.state
      locationSearchInput = location.state.searchInput || '';
      locationOptionValue = location.state.optionValue || 'all';
      locationSchoolName = location.state.schoolName || '';
    } else if (!impersonationReturnHandled.current) {
      // Fallback: check localStorage for return context
      try {
        const storedReturn = localStorage.getItem('impersonation_return');
        if (storedReturn) {
          const returnData = JSON.parse(storedReturn);
          // Only use if timestamp is recent (within last 5 minutes)
          const timestamp = new Date(returnData.timestamp);
          const now = new Date();
          const diffMinutes = (now - timestamp) / 1000 / 60;
          if (diffMinutes < 5) {
            shouldHandle = true;
            returnSchoolId = returnData.schoolId;
            returnStudentId = returnData.studentId;
            // Store search state for later restoration (from impersonation_return)
            if (returnData.searchInput || returnData.optionValue || returnData.schoolName) {
              localStorage.setItem('impersonation_return_search', JSON.stringify({
                searchInput: returnData.searchInput || '',
                optionValue: returnData.optionValue || 'all',
                schoolName: returnData.schoolName || ''
              }));
            }
          }
          // Clear the stored return context after reading
          localStorage.removeItem('impersonation_return');
        }
      } catch (e) {
      }
    }

    if (shouldHandle && returnSchoolId && returnStudentId) {
      impersonationReturnHandled.current = true;

      // Try to restore student page state from location.state first, then impersonation context, then fallback to other sources
      let restoredSearchInput = locationSearchInput || '';
      let restoredSchoolName = locationSchoolName || '';
      let restoredOptionValue = locationOptionValue || 'all';

      try {
        // If not found in location.state, try to get from impersonation context
        if (!restoredSearchInput && !restoredSchoolName) {
          const storedImpersonationContext = localStorage.getItem('impersonation_context');
          if (storedImpersonationContext) {
            const impersonationContext = JSON.parse(storedImpersonationContext);
            restoredSearchInput = impersonationContext.searchInput || '';
            restoredSchoolName = impersonationContext.schoolName || '';
            restoredOptionValue = impersonationContext.optionValue || 'all';
          }
        }

        // Second, try to get from impersonation_return_search (from localStorage return context)
        if (!restoredSearchInput && !restoredSchoolName) {
          const storedReturnSearch = localStorage.getItem('impersonation_return_search');
          if (storedReturnSearch) {
            const returnSearch = JSON.parse(storedReturnSearch);
            restoredSearchInput = returnSearch.searchInput || '';
            restoredSchoolName = returnSearch.schoolName || '';
            restoredOptionValue = returnSearch.optionValue || 'all';
          }
          localStorage.removeItem('impersonation_return_search');
        }

        // Fallback to student_page_state if still no search data
        if (!restoredSearchInput && !restoredSchoolName) {
          const storedPageState = localStorage.getItem('student_page_state');
          if (storedPageState) {
            const pageState = JSON.parse(storedPageState);
            // Only restore if timestamp is recent (within last 30 minutes)
            const timestamp = new Date(pageState.timestamp);
            const now = new Date();
            const diffMinutes = (now - timestamp) / 1000 / 60;
            if (diffMinutes < 30) {
              restoredSearchInput = pageState.searchInput || '';
              restoredSchoolName = pageState.schoolName || '';
              restoredOptionValue = pageState.optionValue || 'all';
            }
          }
        }

        // Apply restored state
        setSchoolName(restoredSchoolName);
        setSearchInput(restoredSearchInput);
        setOptionValue(restoredOptionValue);

        // Update the input ref value to match restored search input
        if (studentInputRef.current && restoredSearchInput) {
          studentInputRef.current.value = restoredSearchInput;
        }

        // Clean up stored states
        localStorage.removeItem('student_page_state');

        // Set school context
        setSchoolId(returnSchoolId);

        // Execute search or fetch students based on restored state
        if (restoredSearchInput) {
          // If there was a search query, execute the search
          const searchObj = {
            page: 1,
            role: "student",
            school: returnSchoolId,
            student_option: "",
            q: restoredSearchInput
          };
          GetStudentService.getStudent(searchObj)
          .then((data) => {
            setStudentListData(data.data);
          })
          .catch(() => {});
        } else {
          // Otherwise fetch with the restored option value
          const fetchObj = {
            page: 1,
            role: "student",
            student: restoredOptionValue || 'all',
            school: returnSchoolId
          };
          GetStudentService.getStudent(fetchObj)
          .then((data) => {
            setStudentListData(data.data);
          })
          .catch(() => {});
        }
      } catch (e) {
        // Fallback: just fetch all students
        setSchoolId(returnSchoolId);
        getStudentwithId("all", returnSchoolId, 1);
      }

      // Open modify student drawer
      setLoading(true);
      GetStudentService.modifyStudent(returnStudentId)
      .then((data) => {
        if (!data.data.objects) {
          setModifyData({
            student: {
              first_name: "",
              last_name: "",
              mobile: "",
              email: "",
              id: returnStudentId
            }
          });
        } else {
          setModifyData(data.data.objects);
        }
        setLoading(false);
        setOpenModifyStudent(true);
      })
      .catch((_error) => {
        setLoading(false);
      });

      // Clear the location state to prevent re-triggering
      history.replace({ pathname: location.pathname, state: {} });
      // Clear impersonation context from localStorage
      localStorage.removeItem('impersonation_context');
    }
  }, [location]);

  const students_without_counselor = (id, pageNum = page) => {
    // CreateStudent refreshes with getStudentwithId("all") — ignore that and use schoolId
    const school =
    id && id !== "all" && id !== "with_id" && id !== "without_id" ?
    id :
    schoolId;
    if (!school) return;
    GetAdminService.withoutCounselor(pageNum, school)
    .then((data) => {
      setStudentListData(data?.data);
    })
    .catch(() => {});
  };

  const StudentsHandler = () => {
    clearTimeout(timeout.current);
    setSearchInput(studentInputRef.current.value);
    timeout.current = setTimeout(() => {
      getStudentfromSearchHandler(studentInputRef.current.value);
    }, 500);
  };

  const handleSchoolName = () => {
    clearTimeout(timeoutRef.current);
    setSchoolName(schoolNameRef.current.value);
    if (!schoolNameRef.current.value) {
      setShowSchoolNameContainer(false);
      setSchoolNameList([]);
      setStudentListData([]);
    } else {
      timeoutRef.current = setTimeout(() => {
        getSchoolsList(schoolNameRef.current.value);
      }, 1000);
    }
  };

  const handleSelectedSchoolName = (item) => {
    setSchoolNameList([item]);
    setShowSchoolNameContainer(false);
    setSchoolName(item.name);
    setSchoolId(item?.id);
    setPage(1);
    if (withoutCounselor) students_without_counselor(item?.id, 1);else
    getStudentwithId("all", item?.id, 1);
  };

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="csv-import-container">
            {/* Page Header */}
            <div className="admin-students-page-header">
              <h2>{withoutCounselor ? "Students without Counselors" : "Students"}</h2>
              {schoolId && !withoutCounselor &&
              <button
                onClick={() => setOpenCreateStudent(true)}
                className="admin-students-new-btn">
                
                  <FontAwesomeIcon icon={faUsers} />
                  New Student
                </button>}
              
            </div>

            {/* School Selector */}
            <div className="admin-students-school-selector">
              <label>Select School</label>
              <div className="school-input-wrapper">
                <input
                  ref={schoolNameRef}
                  type="text"
                  placeholder="Type to search school name..."
                  value={schoolName}
                  onChange={handleSchoolName}
                  autoComplete="off" />
                
                {showSchoolNameContainer &&
                <ul className="school-dropdown">
                    {schoolNameLoading && <CustomLoader />}
                    {schoolNameList?.length > 0 &&
                  schoolNameList.map((item, index) =>
                  <li
                    onClick={() => handleSelectedSchoolName(item)}
                    key={index}>
                    
                          {item.name}
                        </li>
                  )}
                  </ul>}
                
              </div>
            </div>

            {schoolId &&
            <div className="admin-student-list-container admin-students-list-section">
                {!withoutCounselor &&
              <>
                    <div className="admin-students-search-bar">
                      <input
                    type="text"
                    ref={studentInputRef}
                    placeholder="Search students by name or email..."
                    onChange={StudentsHandler}
                    value={searchInput} />
                  
                    </div>
                    <p className="students-section-heading">Students</p>
                    <div className="admin-students-filter-row">
                      <span className="filter-label">Show:</span>
                      <button
                    className={`filter-btn ${optionValue === "all" ? "active" : ""}`}
                    onClick={() => getStudentwithId("all")}>
                    
                        All
                      </button>
                      <button
                    className={`filter-btn ${optionValue === "with_id" ? "active" : ""}`}
                    onClick={() => getStudentwithId("with_id")}>
                    
                        With ID
                      </button>
                      <button
                    className={`filter-btn ${optionValue === "without_id" ? "active" : ""}`}
                    onClick={() => getStudentwithId("without_id")}>
                    
                        Without ID
                      </button>
                    </div>
                  </>}
              

                {loading ?
              <CustomLoader /> :
              studentListData && studentListData.result ?
              studentListData.result.length > 0 ?
              studentListData.result.map((item, index) =>
              <div
                className={`student-list ${index ===
                modifyStudentIndex && "student-list-active"}`}
                onClick={() => modifyStudent(item, index)}
                key={index}>
                
                        <span className="student-name">{`${item.last_name}, ${item.first_name}`}</span>
                        <span className="student-email">{item.email}</span>
                      </div>
              ) :

              <p style={{ color: "#9ca3af", fontSize: "14px" }}>No records found</p> :


              <p style={{ color: "#9ca3af", fontSize: "14px" }}>{studentListData?.status}</p>}
              

                {studentListData && studentListData?.page_list?.length > 1 &&
              <div style={{ margin: "20px 0" }}>
                    <CustomPagination
                  count={studentListData && studentListData}
                  pageValue={page}
                  setPage={setPage} />
                
                  </div>}
              
                {openCreateStudent &&
              <CreateStudent
                setOpenCreateStudent={setOpenCreateStudent}
                modify={false}
                school_id={schoolId}
                getStudentwithId={getStudentwithId} />}

              
                {openModifyStudent && (
              withoutCounselor ?
              <CreateStudent
                setOpenCreateStudent={setOpenModifyStudent}
                modify={modifyData}
                school_id={schoolId}
                getStudentwithId={students_without_counselor}
                getCounselor={withoutCounselor} /> :


              <CreateStudent
                setOpenCreateStudent={setOpenModifyStudent}
                modify={modifyData}
                school_id={schoolId}
                getStudentwithId={getStudentwithId} />)}

              
              </div>}
            
          </div>
        </div>
      </div>
    </Fragment>);

};

export default Students;